(() => {
  if (customElements.get('bba-offer-timer')) return;
  class BbaOfferTimer extends HTMLElement {
    connectedCallback() {
      this.deadline = Date.parse(this.dataset.endsAt);
      this.update = this.update.bind(this);
      this.onVisibility = () => {
        clearInterval(this.interval);
        if (document.hidden) return;
        if (this.update()) this.interval = setInterval(this.update, 1000);
      };
      this.addEventListener('click', this.checkExpiry = event => {
        if (!this.update()) event.preventDefault();
      });
      document.addEventListener('visibilitychange', this.onVisibility);
      this.onVisibility();
    }
    disconnectedCallback() {
      clearInterval(this.interval);
      document.removeEventListener('visibilitychange', this.onVisibility);
      this.removeEventListener('click', this.checkExpiry);
    }
    update() {
      const remaining = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));
      if (!Number.isFinite(remaining) || remaining <= 0) {
        this.hidden = true;
        clearInterval(this.interval);
        return false;
      }
      const values = { days: Math.floor(remaining / 86400), hours: Math.floor(remaining / 3600) % 24, minutes: Math.floor(remaining / 60) % 60, seconds: remaining % 60 };
      for (const [unit, value] of Object.entries(values)) {
        const target = this.querySelector(`[data-unit="${unit}"]`);
        if (target) target.textContent = String(value).padStart(2, '0');
      }
      this.hidden = false;
      return true;
    }
  }
  customElements.define('bba-offer-timer', BbaOfferTimer);
})();
